<template>
  <div class="container mt-4">
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="breadcrumb-container">
      <router-link to="/atencion">Atenciones</router-link> >
      <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_numero }}</router-link>
      > Plan de Vacunación
    </div>
    <hr>
    <div class="row mb-3">
      <div class="col-md-4">
        <label for="filtroVacuna" class="form-label">Filtrar por Vacuna:</label>
        <select id="filtroVacuna" v-model="filtroVacuna" class="form-control">
          <option value="">Todas las Vacunas</option>
          <option v-for="vacuna in vacunas" :key="vacuna" :value="vacuna">{{ vacuna }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label for="mesDesde" class="form-label">Mes Desde:</label>
        <input type="number" id="mesDesde" v-model="mesDesde" class="form-control" min="0" readonly>
      </div>
      <div class="col-md-2">
        <label for="mesHasta" class="form-label">Mes Hasta:</label>
        <input type="number" id="mesHasta" v-model="mesHasta" class="form-control" min="0" readonly>
      </div>
      <div class="col-md-4 d-flex align-items-end justify-content-center">
        <button @click="cambiarPagina(-1)" class="btn btn-primary" :disabled="mesDesde === 0">Anterior Año</button>
        <span class="mx-2 year-label">Año: {{ anioActual }}</span>
        <button @click="cambiarPagina(1)" class="btn btn-primary ml-2">Siguiente Año</button>
      </div>
    </div>
    <div v-if="datosCargados">
      <h3 class="mt-4 mb-3 text-center">Plan de Vacunación</h3>
      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>Vacuna</th>
              <th v-for="mes in rangoMeses" :key="mes">{{ mes }} meses</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vacuna in vacunasFiltradas" :key="vacuna">
              <td>{{ vacuna }}</td>
              <td v-for="mes in rangoMeses" :key="mes">
                <span v-if="isVacunaAplicada(vacuna, mes)" :title="getDescripcion(vacuna, mes)">✔️</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";

export default {
  props: {
    p_idAtencion: {
      type: Number,
      required: true,
    },
    p_numero: {
      type: String,
      required: true,
    },
  },
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      datosCargados: false,
      vacunas: [],
      vacunacionData: [],
      mesDesde: 0,
      mesHasta: 12,
      filtroVacuna: '',
    };
  },
  computed: {
    rangoMeses() {
      let meses = [];
      for (let i = this.mesDesde; i <= this.mesHasta; i++) {
        meses.push(i);
      }
      return meses;
    },
    anioActual() {
      return this.mesDesde / 12 + 1;
    },
    vacunasFiltradas() {
      if (this.filtroVacuna) {
        return this.vacunas.filter(vacuna => vacuna === this.filtroVacuna);
      }
      return this.vacunas;
    }
  },
  methods: {
    async cargarDatos() {
      try {
        const response = await api.get('/vwvacunaplans');
        this.vacunacionData = response.data;
        this.vacunas = [...new Set(this.vacunacionData.map(item => item.vacunaNombre))];
        this.filtrarDatos();
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      }
    },
    filtrarDatos() {
      this.datosCargados = true;
    },
    isVacunaAplicada(vacuna, mes) {
      return this.vacunacionData.some(item => item.vacunaNombre === vacuna && item.edadMeses === mes);
    },
    getDescripcion(vacuna, mes) {
      const vacunaItem = this.vacunacionData.find(item => item.vacunaNombre === vacuna && item.edadMeses === mes);
      return vacunaItem ? vacunaItem.descripcion : '';
    },
    cambiarPagina(direccion) {
      const incremento = 12 * direccion;
      if (this.mesDesde + incremento >= 0) {
        this.mesDesde += incremento;
        this.mesHasta += incremento;
        this.filtrarDatos();
      }
    }
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.cargarDatos();
  },
};
</script>

<style scoped>
.breadcrumb-container {
  margin-bottom: 15px;
}

h3.text-center {
  text-align: center;
}

.table-responsive {
  overflow-x: auto;
}

table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
}

table, th, td {
  border: 1px solid black;
}

th, td {
  padding: 10px;
}

.table-hover tbody tr:hover {
  background-color: #f5f5f5;
}

.d-flex {
  display: flex;
}

.align-items-end {
  align-items: flex-end;
}

.justify-content-center {
  justify-content: center;
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.year-label {
  font-weight: bold;
  font-size: 1.2rem;
}
</style>